<template>
    <div class="container">
        <slot />
    </div>
</template>

<style scoped>
.container {
    width: 88%;
    max-width: var(--container-width, 1240px);
    margin: auto;
}

@media (max-width: 1024px) {
    .container {
        width: 88%;
    }
}

@media (max-width: 767px) {
    .container {
        width: 90%;
    }
}
</style>
